import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { ACResourceService } from '@appcatalyst/ng-cms-core-lib';
import { map, first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GroupService {
  private group = new ReplaySubject<string>(1);

  constructor(private cms: ACResourceService) {
  }

  public updateGroup = (code: string) => {
    this.group.next(code)
    return code
  }

  public getGroup = (): Observable<string> => {
    return this.group.asObservable()
  }
}
